<script setup lang="ts">
import { Button } from '@collector/shared-ui'

interface Props {
  disabled?: boolean
}

defineProps<Props>()
</script>

<template>
  <!-- TODO: make variant instead of class (when disabled, no hover or active)-->
  <Button
    class="border-neutral-light-7 bg-neutral-light-7"
    :class="{
      'hover:bg-neutral-light-3 hover:border-neutral-light-3 active:bg-neutral-light-0 active:border-neutral-light-0':
        !disabled,
    }"
    size="sm"
    square
    :disabled
  />
</template>
